import type { CSSProperties } from 'react';

export const alignInlineStyles: CSSProperties = {
  transform: 'translateY(0.125em)',
};
